import type { StepMap, StepSource } from "@/Modules/Models/Domain/OnBoarding";
import {
  AnswersIds,
  ChoicesName,
  StepId,
  ReasonReassign,
  AREA_NAME_COACHING,
  SUBSCRIPTION_ACTIVE_THERAPIST_KNOWN,
  AREA_EXTRA_THERAPIST_KNOW,
  OTHER_LOCATION,
} from "@/Modules/Models/Domain/OnBoarding";

// @ts-expect-error THER-6617
export const reassignStepSource: StepSource = {
  [StepId.REASSIGN_REASON]: {
    highlightedTitle: "onboarding.step.reassign_reason.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.REASSIGN_REASON,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.REASSIGN_REASONS,
      },
    ],
  },
  [StepId.DETAILS_REASSIGN_CURRENT]: {
    highlightedTitle: "onboarding.step.details_reassign.specific_current.title_highlighted",
    subtitle: "onboarding.step.details_reassign.specific_current.subtitle",
    infoField: ["onboarding.step.details_reassign.specific_current.info"],
    actionButton: true,
    components: [
      {
        id: AnswersIds.DETAILS_REASSIGN,
        value: "",
        mandatory: true,
        name: "TcTextarea",
        maxCharacters: 300,
        counter: true,
        placeholder: "onboarding.step.details_reassign.placeholder",
      },
    ],
  },
  [StepId.DETAILS_REASSIGN_SCHEDULE]: {
    highlightedTitle: "onboarding.step.details_reassign.time_incompatibility.title_highlighted",
    infoField: ["onboarding.step.details_reassign.time_incompatibility.info"],
    actionButton: true,
    components: [
      {
        id: AnswersIds.DETAILS_REASSIGN,
        value: "",
        mandatory: true,
        name: "TcTextarea",
        maxCharacters: 300,
        counter: true,
        placeholder: "onboarding.step.details_reassign.placeholder",
        label: "onboarding.step.details_reassign.time_incompatibility.label",
      },
    ],
  },
  [StepId.DETAILS_REASSIGN_LACK_OF_CONNECTION]: {
    title: "onboarding.step.details_reassign.connection_missing.title",
    highlightedTitle: "onboarding.step.details_reassign.connection_missing.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.DETAILS_REASSIGN,
        value: "",
        mandatory: true,
        name: "TcTextarea",
        maxCharacters: 300,
        counter: true,
        placeholder: "onboarding.step.details_reassign.placeholder",
      },
    ],
  },
  [StepId.DETAILS_REASSIGN_POOR_MANAGEMENT]: {
    title: "onboarding.step.details_reassign.therapist_mismanagement.title",
    highlightedTitle: "onboarding.step.details_reassign.therapist_mismanagement.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.DETAILS_REASSIGN,
        value: "",
        mandatory: true,
        name: "TcTextarea",
        maxCharacters: 300,
        counter: true,
        placeholder: "onboarding.step.details_reassign.placeholder",
      },
    ],
  },
  [StepId.MAIN_AREA]: {
    title: "onboarding.step.main_area.title",
    highlightedTitle: "onboarding.step.main_area.title_highlighted",
    subtitle: "onboarding.step.main_area.subtitle",
    infoField: ["onboarding.step.main_area.info"],
    actionButton: true,
    components: [
      {
        id: AnswersIds.MAIN_AREA,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.MAIN_AREA,
        filterChoices: {
          param: "name",
          value: AREA_NAME_COACHING,
          equal: false,
        },
      },
    ],
  },
  [StepId.SUB_AREA]: {
    title: "onboarding.step.subarea.title",
    highlightedTitle: "onboarding.step.subarea.title_highlighted",
    actionButton: true,
    infoSpecialMainArea: "depression",
    components: [
      {
        id: AnswersIds.SUB_AREA,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.SUB_AREA,
        filterChoices: {
          param: "isCouple",
          value: false,
        },
      },
    ],
  },
  [StepId.THERAPIST_NAME]: {
    highlightedTitle: "onboarding.step.therapist_name.title_highlighted",
    actionButton: true,
    components: [
      {
        id: AnswersIds.THERAPIST_NAME,
        value: "",
        mandatory: true,
        type: "text",
        name: "TcInput",
        placeholder: "onboarding.step.therapist_name.placeholder",
        maxCharacters: 100,
        minCharacters: 5,
      },
    ],
  },
  [StepId.ZONE]: {
    title: "onboarding.step.zone.title",
    highlightedTitle: "onboarding.step.zone.title_highlighted",
    subtitle: "onboarding.step.zone.subtitle",
    actionButton: true,
    components: [
      {
        id: AnswersIds.ZONE,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.ZONES,
      },
    ],
  },
  [StepId.TIME_AFFECTED]: {
    title: "onboarding.step.time_affected.title",
    actionButton: true,
    components: [
      {
        id: AnswersIds.TIME_AFFECTED,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        options: [
          {
            title: "onboarding.step.time_affected.option1.title",
            value: "days",
          },
          {
            title: "onboarding.step.time_affected.option2.title",
            value: "weeks",
          },
          {
            title: "onboarding.step.time_affected.option3.title",
            value: "month",
          },
          {
            title: "onboarding.step.time_affected.option4.title",
            value: "months",
          },
          {
            title: "onboarding.step.time_affected.option5.title",
            value: "years",
          },
        ],
      },
    ],
  },
  [StepId.TELL_ME_MORE]: {
    title: "onboarding.step.tell_me_more.title",
    highlightedTitle: "onboarding.step.tell_me_more.title_highlighted",
    actionButton: true,
    infoField: ["onboarding.step.tell_me_more.info"],
    components: [
      {
        id: AnswersIds.TELL_ME_MORE,
        value: "",
        mandatory: false,
        name: "TcTextarea",
        maxCharacters: 300,
        counter: true,
        placeholder: "onboarding.step.tell_me_more.placeholder",
        label: "onboarding.step.tell_me_more.label",
      },
    ],
  },
  [StepId.THERAPIST_GENDER_PREFERENCES]: {
    title: "onboarding.step.therapist_gender_preferences.title",
    highlightedTitle: "onboarding.step.therapist_gender_preferences.title_highlighted",
    actionButton: true,
    infoField: ["onboarding.step.therapist_gender_preferences.info"],
    components: [
      {
        id: AnswersIds.THERAPIST_GENDER_PREFERENCES,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.GENDER_PREFERENCES,
      },
    ],
  },
  [StepId.THERAPIST_AVAILABILITIES]: {
    title: "onboarding.step.therapist_availabilities.title",
    highlightedTitle: "onboarding.step.therapist_availabilities.title_highlighted",
    subtitle: "onboarding.step.therapist_availabilities.subtitle",
    infoField: ["onboarding.step.therapist_availabilities.info"],
    actionButton: true,
    components: [
      {
        id: AnswersIds.THERAPIST_AVAILABILITY,
        value: "",
        mandatory: true,
        name: "TcCheckList",
        choicesName: ChoicesName.AVAILABILITIES,
      },
    ],
  },
};

// @ts-expect-error THER-6617
export const reassignStepMap: StepMap = {
  [StepId.WELCOME_REASSIGN]: [
    {
      id: "*",
      nextStep: StepId.REASSIGN_REASON,
    },
  ],
  [StepId.REASSIGN_REASON]: [
    {
      id: ReasonReassign.SCHEDULE,
      nextStep: StepId.ZONE,
    },
    {
      id: ReasonReassign.THERAPIST_LEAVES,
      nextStep: StepId.MAIN_AREA,
    },
    {
      id: ReasonReassign.WRONG_AREA,
      nextStep: StepId.MAIN_AREA,
    },
    {
      id: ReasonReassign.KNOWN_THERAPIST,
      nextStep: StepId.THERAPIST_NAME,
    },
    {
      id: ReasonReassign.CURRENT,
      nextStep: StepId.DETAILS_REASSIGN_CURRENT,
    },
    {
      id: ReasonReassign.POOR_MANAGEMENT,
      nextStep: StepId.DETAILS_REASSIGN_POOR_MANAGEMENT,
    },
    {
      id: ReasonReassign.LACK_OF_CONNECTION,
      nextStep: StepId.DETAILS_REASSIGN_LACK_OF_CONNECTION,
    },
  ],
  [StepId.MAIN_AREA]: [
    {
      id: "*",
      nextStep: StepId.SUB_AREA,
    },
  ],
  [StepId.SUB_AREA]: [
    {
      id: "*",
      nextStep: StepId.TELL_ME_MORE,
    },
  ],
  [StepId.DETAILS_REASSIGN_CURRENT]: [
    {
      id: "*",
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
  ],
  [StepId.DETAILS_REASSIGN_SCHEDULE]: [
    {
      id: "*",
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
  ],
  [StepId.DETAILS_REASSIGN_LACK_OF_CONNECTION]: [
    {
      id: "*",
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
  ],
  [StepId.DETAILS_REASSIGN_POOR_MANAGEMENT]: [
    {
      id: "*",
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
  ],
  [StepId.THERAPIST_NAME]: [
    {
      id: "*",
      nextStep: StepId.TELL_ME_MORE,
    },
  ],
  [StepId.ZONE]: [
    {
      id: OTHER_LOCATION,
      nextStep: StepId.DETAILS_REASSIGN_SCHEDULE,
    },
    {
      id: "*",
      nextStep: StepId.THERAPIST_AVAILABILITIES,
    },
  ],
  [StepId.TELL_ME_MORE]: [
    {
      id: SUBSCRIPTION_ACTIVE_THERAPIST_KNOWN,
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
    {
      id: AREA_EXTRA_THERAPIST_KNOW,
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
    {
      id: "*",
      nextStep: StepId.THERAPIST_GENDER_PREFERENCES,
    },
  ],
  [StepId.THERAPIST_GENDER_PREFERENCES]: [
    {
      id: "*",
      nextStep: StepId.THERAPIST_AVAILABILITIES,
    },
  ],
  [StepId.THERAPIST_AVAILABILITIES]: [
    {
      id: "*",
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
  ],
  [StepId.NICE_CHOICE_MY_FRIEND]: [
    {
      id: "*",
      nextStep: StepId.NICE_CHOICE_MY_FRIEND,
    },
  ],
};
